import type {
	ClientPortfolioDetailToolResponseDTO,
	ClientPortfolioProducerInstrumentResponseDTO,
	ClientPortfolioToolReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";

export const ToolType = {
	Commodity: "commodity",
	Crypto: "crypto",
	Investment: "investment",
	Bond: "bond",
	BankProduct: "bankProduct",
	Default: "default",
} as const;

export type ToolType = (typeof ToolType)[keyof typeof ToolType];

export type ToolRowCommonProps = {
	tool: ClientPortfolioDetailToolResponseDTO;
	toolIdx: number;
	portfolioId: number;
	currencySign: string;
	toolsSummary?: ClientPortfolioToolReportingSummaryResponseDTO[];
	expanded: boolean;
	onToggle: (value: boolean) => void;
	noDivider: boolean;
};

export type ProducerInstrumentRowProps = {
	producerInstrument: ClientPortfolioProducerInstrumentResponseDTO;
	instrumentIdx: number;
	portfolioId: number;
	currencySign: string;
	expanded: boolean;
	onToggle: (value: boolean) => void;
	noDivider: boolean;
};
